<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <base-card
            :title="$route.query.page_title + ' List'"
            icon="mdi-clock-alert-outline"
          >

              <v-card-text class="pa-0">
                <v-row class="py-2">

                  <v-col md="4" cols="12">
                    <v-text-field 
                      v-model="search" 
                      append-inner-icon="mdi-magnify" 
                      label="Search" single-line
                      hide-details 
                      density="compact" 
                      variant="outlined" 
                      bg-color="grey-lighten-4" 
                      class="pl-2"
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                        <v-btn prepend-icon="mdi-download" variant="flat" color="success" @click="exportToCSV">
                          CSV
                        </v-btn>
                        <v-btn prepend-icon="mdi-download" variant="flat" color="primary" @click="exportToExcel">
                          EXCEL
                        </v-btn>
                        <v-btn prepend-icon="mdi-download" variant="flat" color="red" @click="exportToPDF">
                          PDF
                        </v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="text-right">
                      <v-btn @click="refreshList" color="secondary" variant="tonal" prepend-icon="mdi-refresh"
                        rounded="xl">
                        Refresh
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-card elevation="1">
                  <v-data-table
                    density="compact"
                    style="white-space: nowrap;"
                    :loading="loading"
                    hover
                    hide-default-footer
                  >
                    <thead>
                      <tr>
                        <th class="text-center" >#SL</th>
                        <th class="text-center">Code</th>
                        <th class="text-center">Created By</th>
                        <!-- <th v-if="getModelClass != 'Modules\\Leave\\Models\\Leave'" class="text-center">Warehouse</th>
                        <th v-if="getModelClass != 'Modules\\Leave\\Models\\Leave'" class="text-center">Department</th>
                        <th class="text-center">Date</th>
                        <th v-if="getModelClass != 'Modules\\Leave\\Models\\Leave'" class="text-center">Party</th>
                        <th v-if="getModelClass != 'Modules\\Leave\\Models\\Leave'" class="text-center">Total Items</th>
                        <th v-if="getModelClass != 'Modules\\Leave\\Models\\Leave'" class="text-center">Total</th> -->
                        <th class="text-center">Common Info</th>
                        <th v-if="getModelClass == 'Modules\\Leave\\Models\\Leave'" class="text-center">Balance</th>
                        <th class="text-center">Actions</th>
                        <th class="text-center">Process</th>
                      </tr>
                    </thead>

                    <tbody>
                      <template v-for="(item, index) in getPendingVouchers" :key="item.id">
                        <!-- Voucher Row -->
                        <tr class="voucher-row">
                          <td class="text-center">{{ index + 1 }}</td>
                          <td class="text-center">
                            <span v-if="!viewUrl">{{ item.code }}</span>
                            <a href="javascript:void(0)" v-if="viewUrl" @click="viewApprovalDetails(item)">{{ item.code }}</a>
                          </td>
                          <td>{{ item?.created_by?.full_name }}</td>

                          <!-- <td v-if="getModelClass != 'Modules\\Leave\\Models\\Leave'" class="text-center">{{ item?.common_data?.warehouse?.name || "-" }}</td>
                          <td v-if="getModelClass != 'Modules\\Leave\\Models\\Leave'" class="text-center">{{ item?.common_data?.department?.name || "-" }}</td>
                          <td class="text-center">{{ item?.common_data?.date || "-" }}</td>
                          <td v-if="getModelClass != 'Modules\\Leave\\Models\\Leave'" class="text-center">{{ item?.common_data?.party || "-" }}</td>
                          <td v-if="getModelClass != 'Modules\\Leave\\Models\\Leave'" class="text-center">{{ item?.common_data?.total_item || "-" }}</td>
                          <td v-if="getModelClass != 'Modules\\Leave\\Models\\Leave'" class="text-center">{{ item?.common_data?.total || "-" }}</td> -->
                          <td class="text-left">
                            <p v-if="item?.common_data?.lc_date"><strong>Lc Date:</strong> {{ item?.common_data?.lc_date || "-" }}</p>
                            <p v-if="item?.common_data?.pi_nos"><strong>PI Nos:</strong>
                              <v-chip
                                  color="primary"
                                  size="small"
                                  v-for="(item) in item?.common_data?.pi_nos"
                              >
                                {{ item }}
                              </v-chip>
                            </p>
                            <p v-if="item?.common_data?.date"><strong>Date:</strong> {{ formatDateDash(item?.common_data?.date) || "-" }}</p>
                            <p v-if="item?.common_data?.sale_order_date"><strong>Sale Order Date:</strong> {{ item?.common_data?.sale_order_date || "-" }}</p>
                            <p v-if="item?.common_data?.pi_no"><strong>Pi No.:</strong> {{ item?.common_data?.pi_no || "-" }}</p>
                            <p v-if="item?.common_data?.pi_type"><strong>Pi Type:</strong> {{ item?.common_data?.pi_type || "-" }}</p>
                            <p v-if="item?.common_data?.total_days"><strong>Total Days:</strong> {{ item?.common_data?.total_days || "-" }}</p>
                             <p v-if="item?.common_data?.warehouse?.name"><strong>Warehouse:</strong> {{ item?.common_data?.warehouse?.name || "-" }}</p>
                             <p v-if="item?.common_data?.warehouse"><strong>Warehouse:</strong> {{ item?.common_data?.warehouse || "-" }}</p>
                            <p v-if="item?.common_data?.department?.name"><strong>Department:</strong> {{ item?.common_data?.department?.name || "-" }}</p>
                            <p v-if="item?.common_data?.designation?.name"><strong>Designation:</strong> {{ item?.common_data?.designation?.name || "-" }}</p>
                            <p v-if="item?.common_data?.party"><strong>Party:</strong> {{ item?.common_data?.party || "-" }}</p>
                            <p v-if="item?.common_data?.sales_person"><strong>Sales Person:</strong> {{ item?.common_data?.sales_person || "-" }}</p>
                            <p v-if="item?.common_data?.challan_date"><strong>Challan Date:</strong> {{ item?.common_data?.challan_date || "-" }}</p>
                            <p v-if="item?.common_data?.customer_company_name"><strong>Company Name:</strong> {{ item?.common_data?.customer_company_name || "-" }}</p>
                            <p v-if="item?.common_data?.total_item"><strong>Total Items:</strong> {{ item?.common_data?.total_item || "-" }}</p>
                            <p v-if="item?.common_data?.total"><strong>Total:</strong> {{ item?.common_data?.total || "-" }}</p>
                            <p v-if="item?.common_data?.target_amount"><strong>Target Amount:</strong> {{ item?.common_data?.target_amount || "-" }}</p>
                            <p v-if="item?.common_data?.start_date"><strong>Start Date:</strong> {{ item?.common_data?.start_date || "-" }}</p>
                            <p v-if="item?.common_data?.end_date"><strong>End Date:</strong> {{ item?.common_data?.end_date || "-" }}</p>
                            <p v-if="item?.common_data?.remarks"><strong>Remarks:</strong> {{ item?.common_data?.remarks || "-" }}</p>
                            <p v-if="item?.common_data?.requisition_type"><strong>Requisition Type:</strong> {{ item?.common_data?.requisition_type?.replace(/_/g, ' ')?.replace(/\b\w/g, c => c.toUpperCase()) || "-" }}</p>

                            <p v-if="item?.common_data?.grn_no"><strong>GRN Code:</strong> {{ item?.common_data?.grn_no || "-" }}</p>
                            <p v-if="item?.common_data?.lc_no"><strong>LC no.:</strong> {{ item?.common_data?.lc_no || "-" }}</p>
                            <p v-if="item?.common_data?.shipment_no"><strong>Shipment Code:</strong> {{ item?.common_data?.shipment_no || "-" }}</p>


                            <p v-if="item?.common_data?.employee"><strong>Employee:</strong> {{ item?.common_data?.employee?.name || "-" }}</p>
                            <p v-if="item?.common_data?.actual_in"><strong>Actual In:</strong> {{ item?.common_data?.actual_in || "-" }}</p>
                            <p v-if="item?.common_data?.actual_out"><strong>Actual Out:</strong> {{ item?.common_data?.actual_out || "-" }}</p>
                            <p v-if="item?.common_data?.in_remarks"><strong>In Remarks:</strong> {{ item?.common_data?.in_remarks || "-" }}</p>
                            <p v-if="item?.common_data?.out_remarks"><strong>Out Remarks:</strong> {{ item?.common_data?.out_remarks || "-" }}</p>
                            <p v-if="item?.common_data?.address"><strong>Address:</strong> {{ item?.common_data?.address || "-" }}</p>

                            <p v-if="item?.common_data?.created_by"><strong>Created By:</strong> {{ item?.common_data?.created_by || "-" }}</p>
                          </td>

                          <td v-if="getModelClass == 'Modules\\Leave\\Models\\Leave'" class="text-center">
                            {{ item?.common_data?.balance?.leave_type_name || "-" }} <br>
                            {{ item?.common_data?.balance?.entitled_days || "0" }} / {{ item?.common_data?.balance?.remaining_days || "0" }}
                          </td>

                          <td class="text-left">
                            <!-- <v-icon small @click="viewVoucher(item)" class="me-2" title="View Voucher" color="blue">
                              mdi-file-document-outline
                            </v-icon> -->

                            <v-btn 
                              v-if="viewUrl" 
                              @click="viewApprovalDetails(item)" 
                              color="green" 
                              variant="text" 
                              size="large"
                              class="text-none p-0" 
                              :loading="progressLoading" 
                              :disabled="progressLoading"
                            >
                              <v-icon small class="me-1">mdi-eye</v-icon> 
                              Details
                            </v-btn>

                            <v-btn 
                              v-if="item.is_progress"
                              @click="progressVoucher(item)" 
                              color="orange" 
                              variant="text" 
                              size="large"
                              class="text-none p-0" 
                              :loading="progressLoading" 
                              :disabled="progressLoading"
                            >
                              <v-icon small class="me-1">
                                mdi-progress-clock
                              </v-icon>
                              Progress
                            </v-btn>
                          </td>

                          <td colspan="1" class="pa-0">
                            <div class="timeline-container">
                              <div v-if="item.approval_process && item.approval_process.length > 0"
                                class="horizontal-timeline">
                                <div v-for="(approval, approvalIndex) in item.approval_process" :key="approvalIndex"
                                  class="timeline-step">
                                  <!-- Step connector and other step contents -->
                                  <div v-if="approvalIndex > 0" class="step-connector" :class="{
                                    'connector-approved': item.approval_process[approvalIndex - 1]?.status?.toLowerCase() === 'approved'
                                  }">
                                    <div class="connector-arrow"></div>
                                  </div>
                                  <div class="step-content" >
                                    <div class="step-circle" :class="[
                                      getApprovalClass(approval.status, item.approval_process, approvalIndex),
                                      { 'current-step-pulse': isCurrentStep(item.approval_process, approvalIndex) }
                                    ]">
                                      <v-icon size="medium" color="white">
                                        {{
                                          isCurrentStep(item.approval_process, approvalIndex) && approval.status ===
                                            "Pending"
                                            ? "mdi-reload"
                                        : getApprovalIcon(approval.status)
                                        }}
                                      </v-icon>
                                    </div>
                                    <div class="step-card" :class="[
                                      getApprovalClass(approval.status, item.approval_process, approvalIndex) + '-card',
                                      { 'current-step-highlight': isCurrentStep(item.approval_process, approvalIndex) }
                                    ]">
                                      <div v-if="approval.status === 'Approved' && approval.approved_by">
                                        <div class="step-title-line">
                                          <span class="step-role status-approved-text">Approved By {{ approval.approval_step_name?.name || 'Approver'
                                            }}</span>
                                        </div>
                                        <div class="step-date">
                                          {{ formattedDate(approval.approved_at || approval.created_at) }}
                                        </div>
                                      </div>
                                      <div v-else-if="approval.status === 'Pending'">
                                        <div class="step-title-line">
                                          <span class="step-role" :class="isCurrentStep(item.approval_process, approvalIndex) ? 'current-step-title-text' : 'status-pending-text'">Waiting for {{ approval.approval_step_name?.name || 'Approver'
                                            }}</span>
                                        </div>
                                        <div class="step-date"
                                          v-if="isCurrentStep(item.approval_process, approvalIndex)">
                                          <span class="step-date-label">Started</span>
                                          {{ formattedDate(getCurrentStepStartTime(item.approval_process, approvalIndex)) }}
                                        </div>
                                      </div>
                                      <div v-else-if="approval.status === 'Cancelled'">
                                        <div class="step-title-line">
                                          <span class="step-role status-cancelled-text">Cancelled By {{ approval.approval_step_name?.name || 'Approver'
                                            }}</span>
                                        </div>
                                        <div class="step-date">
                                          {{ formattedDate(approval.approved_at || approval.created_at) }}
                                        </div>
                                      </div>
                                      <div v-else>
                                        <div class="step-title-line">
                                          <span class="step-role">{{ approval.approval_step_name?.name || 'Approver'
                                            }}</span>
                                        </div>
                                        <div class="step-date">
                                          {{ formattedDate(approval.created_at) }}
                                        </div>
                                      </div>

                                  <!-- <div v-if="approval.comments" class="step-comments">
                                        <v-icon size="x-small">mdi-message-text</v-icon>
                                        {{ approval.comments }}
                                      </div> -->

                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div v-else class="text-center py-6">
                                <v-icon size="60" color="grey-lighten-1">mdi-timeline-alert-outline</v-icon>
                                <p class="text-body-2 text-grey mt-3">No approval workflow configured</p>
                              </div>
                            </div>
                          </td>

                          <!-- <td class="text-center">
                            <v-chip
                              :color="approvalStatus[item.approval_status]?.color || 'orange'"
                              size="small"
                              class="text-capitalize"
                            >
                              {{ item.approval_status || "Pending" }}
                            </v-chip>
                          </td> -->
                          <!-- <td class="text-center">
                            <v-chip
                              :color="statusMap[item.status]?.color || 'grey'"
                              size="small"
                              class="text-capitalize"
                            >
                              {{ statusMap[item.status]?.label || "Unknown" }}
                            </v-chip>
                          </td> -->
                        </tr>

                       
                        <!-- Timeline Row Below Each Voucher -->


                      </template>
                    </tbody>
                  </v-data-table>

                  <!-- Pagination -->
                  <div class="text-center pa-4">
                    <v-pagination 
                      v-model="page" 
                      :length="(paginationLength/itemsPerPage) +1" 
                      :total-visible="7">
                    </v-pagination>
                  </div>
                </v-card>
              </v-card-text>
          </base-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import statusMap from "@/utils/statusMap";
import approvalStatus from "@/utils/approvalStatus";
import baseCard from "@/components/utils/baseCard.vue";
import {formatDateDash, formatDateView} from "@/plugins/helpers.js";

export default {
  name: "JournalRequestList",
  components: {
    baseCard,
  },
  data: () => ({
    itemsPerPage: 12,
    panel: [0],
    loading: false,
    progressLoading: false,
    search: "",
    paginationLength: 1,
    statusMap,
    approvalStatus,
    page: 1,
    headers: [
      { title: "#SL", align: "center", key: "index", width: "5%", sortable: false, },
      { title: "Code", key: "code", align: "center", sortable: false },
      { title: "Voucher Date", key: "voucher_date", align: "center", sortable: false, },
      { title: "Total Debit", key: "total_debit", align: "right", sortable: false, },
      { title: "Total Credit", key: "total_credit", align: "right", sortable: false, },
      { title: "Narration", key: "remarks", align: "left", sortable: false },
      { title: "Approval Status", align: "center", key: "approval_status", sortable: false, },
      { title: "Status", align: "center", key: "voucher_status", sortable: false, },
      { title: "Actions", align: "center", key: "actions", sortable: false },
    ],
    responseData: null,
  }),

  created() {
    this.loadPendingVouchers();
  },

  watch: {
    search() {
      this.page = 1;
    },
    // Watch for route changes to reload data when switching between different voucher types
    '$route.query': {
      handler(newQuery, oldQuery) {
        // Check if relevant query parameters have changed
        if (
          newQuery.voucher_type !== oldQuery?.voucher_type ||
          newQuery.model !== oldQuery?.model ||
          newQuery.page_title !== oldQuery?.page_title
        ) {
          console.log('Route query changed, reloading data...', {
            from: oldQuery,
            to: newQuery
          });
          // Reset pagination to first page when switching voucher types
          this.page = 1;
          // Reload the data with new parameters
          this.loadPendingVouchers();
        }
      },
      deep: true
    }
  },

  computed: {
    getPendingVouchers() {
      const vouchers = this.$store.getters.getVoucherList || [];

      let filtered = vouchers.filter(
        voucher =>
          voucher.approval_status === "Pending" || !voucher.approval_status
      );

      if (this.search) {
        const keyword = this.search.toLowerCase();

        filtered = filtered.filter(item => {
          return (
            item.code?.toLowerCase().includes(keyword) ||
            item.common_data?.warehouse?.name?.toLowerCase().includes(keyword) ||
            item.common_data?.department?.name?.toLowerCase().includes(keyword) ||
            item.common_data?.party?.toLowerCase().includes(keyword) ||
            item.common_data?.remarks?.toLowerCase().includes(keyword) ||
            item.common_data?.created_by?.toLowerCase().includes(keyword)
          );
        });
      }

      this.paginationLength = filtered.length;

      const start = (this.page - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;

      return filtered.slice(start, end);
    },

    getModelClass(){
      return this.responseData?.data?.modelClass;
    },

    getTotalVouchers() {
      const vouchers = this.$store.getters.getVoucherList || [];
      return vouchers.filter(
        (voucher) =>
          voucher.approval_status === "Pending" || !voucher.approval_status
      ).length;
    },
  },

  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        from_date: yup.date().nullable().label("From Date"),
        to_date: yup.date().nullable().label("To Date"),
      }),
    });

    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref(false);
    const store = useStore();
    const route = useRoute();
    const viewUrl = ref(null);

    viewUrl.value = route.query.view_url;

    const submit = handleSubmit((values) => {
      loading.value = 'blue-darken-3';
      const params = {
        model: route.query.model ,
        voucher_type: route.query.voucher_type ,
        page_title: route.query.page_title || null,
        from_date: values.from_date
          ? formattedDate(from_date.value.value)
          : null,
        to_date: values.to_date ? formattedDate(to_date.value.value) : null,
      };

      store
        .dispatch("getApprovalRequestRecord", params)
        .then((response) => {
          this.responseData = response;
          loading.value = false;
          toast.success("Data loaded successfully");
        })
        .catch((error) => {
          loading.value = false;
          toast.error(error.response?.data?.message || "Failed to load data");
        });
    });

    return {
      submit,
      from_date,
      to_date,
      errorMessages,
      loading,
      viewUrl,
    };
  },

  methods: {
    formatDateDash,
    formatDateView,
    formattedDate,
    
    loadPendingVouchers() {
      this.loading = "blue-darken-3";
      // Clear the previous voucher list before loading new data
      this.$store.commit("UNSET_VOUCHER_LIST");
      
      this.$store
        .dispatch("getApprovalRequestRecord", {
          model: this.$route.query.model ,
          voucher_type: this.$route.query.voucher_type ,
          page_title: this.$route.query.page_title || null,
        }).then((response) => {
          this.responseData = response;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    refreshList() {
      this.loadPendingVouchers();
    },

    goTo(val) {
      this.$router.push({ path: val }).catch((err) => { });
    },

    viewVoucher(item) {
      this.$router.push({
        name: "view-journal-voucher",
        params: { id: item.id },
      });
    },

    progressVoucher(item) {
          this.progressLoading = true;

          // Get referenceable_type dynamically from item's approval_process
          let referenceableType = null;
        
          let referenceableId = item.id;

          // Try to get from approval_process relation (if available)
          if (item.approval_process && item.approval_process.length > 0) {
            referenceableType = item.approval_process[0].referenceable_type;
            referenceableId = item.approval_process[0].referenceable_id || item.id;
           
           
          }

          // If not available in approval_process, construct from route model parameter
          if (!referenceableType) {
            const modelName = this.$route.query.model;
         
          
            if (!modelName) {
              console.error("No model name provided in route");
              toast.error("Unable to load approval details. Missing model name.");
              this.progressLoading = false;
              return;
            }

            referenceableType = modelMap[modelName];

            if (!referenceableType) {
             
              toast.error(`Model "${modelName}" is not configured. Please add it to the model map.`);
              this.progressLoading = false;
              return;
            }
          }

        
          // Navigate to approval preview
          this.$router
            .push({
              name: "approval-process-preview",
              params: { id: item.id },
              query: {
                model: "ApprovalProcess",
                page_title: this.$route.query.page_title,
                voucher_type: this.$route.query.voucher_type ,
                referenceable_type: referenceableType,
                referenceable_id: referenceableId,
                view_url: this.$route.query.view_url ,
              },
            })
            .then(() => {
              this.progressLoading = false;
            })
            .catch((error) => {
              toast.error("Navigation failed. Check console/network for details.");
              this.progressLoading = false;
            });
    },

  findRouteByName(routes, name, parentPath = '') {
    for (const route of routes) {
      let fullPath = route.path.startsWith('/')
        ? route.path
        : `${parentPath}/${route.path}`.replace(/\/+/g, '/');
      fullPath = fullPath.replace(/^\/+/, '');

      if (route.name === name) {
        return { ...route, fullPath };
      }

      if (route.children && route.children.length) {
        const found = this.findRouteByName(route.children, name, fullPath);
        if (found) return found;
      }
    }
    return null;
  },

  viewApprovalDetails(item) {
    const routes = this.$router.options.routes;
    const targetRoute = this.findRouteByName(routes, this.viewUrl);

    if (!targetRoute) {
      console.error("Route not found:", this.viewUrl);
      return;
    }

    let resolved;

    const hasIdParam = targetRoute.fullPath.includes(':id');

    if (hasIdParam) {
      this.$router.push({
        name: this.viewUrl,
        params: { id: item.id }
      });
    } else {
      this.$router.push({
        name: this.viewUrl,
        query: { id: item.id }
      });
    }
  },


  // viewApprovalDetails(item) {
  //   const routes = this.$router.options.routes;
  //   const targetRoute = this.findRouteByName(routes, this.viewUrl);

  //   if (!targetRoute) {
  //     console.error("Route not found:", this.viewUrl);
  //     return;
  //   }
  //   const hasIdParam = targetRoute.fullPath.includes(':id');
  //   if (hasIdParam) {
  //     this.$router.push({
  //       name: this.viewUrl,
  //       params: { id: item.id }
  //     });
  //   } else {
  //     this.$router.push({
  //       path: targetRoute.fullPath,
  //       query: { id: item.id }
  //     });
  //   }
  // },


    formatCurrency(value) {
      return parseFloat(value || 0).toFixed(2);
    },

    getApprovalColor(status) {
      if (!status) return "grey";
      const statusLower = status.toLowerCase();
      if (statusLower === "approved") return "success";
      if (statusLower === "pending") return "orange";
      if (statusLower === "rejected" || statusLower === "cancelled")
        return "error";
      return "grey";
    },

    getApprovalClass(status, approval_process, index) {
      if (!status) return "step-circle-grey";
      const statusLower = status.toLowerCase();
      if (statusLower === "approved") return "step-circle-success";
      if (statusLower === "pending") {
        // Check if this is the current pending step
        const isCurrent = this.isCurrentStep(approval_process, index);

        if (isCurrent) {
          return "step-circle-blue";
        }
        return "step-circle-pending";
      }
      if (statusLower === "rejected" || statusLower === "cancelled")
        return "step-circle-error";
      return "step-circle-grey";
    },

    getApprovalIcon(status) {
      if (!status) return "mdi-help";
      const statusLower = status.toLowerCase();
      if (statusLower === "approved") return "mdi-check";
      if (statusLower === 'forwarded') return 'mdi-share';
      if (statusLower === "pending") return "mdi-clock-outline";
      if (statusLower === "rejected" || statusLower === "cancelled")
        return "mdi-close";
      return "mdi-help";
    },

    isCurrentStep(approval_process, index) {
      if (!approval_process || approval_process.length === 0) return false;

      // Find the first pending step - this is the current active step
      const firstPendingIndex = approval_process.findIndex(
        (approval) => approval.status?.toLowerCase() === "pending"
      );

      // If there's a pending step, that's the current one
      if (firstPendingIndex !== -1) {
        return index === firstPendingIndex;
      }

      // If all are approved, highlight the last one
      const allApproved = approval_process.every(
        (approval) => approval.status?.toLowerCase() === "approved"
      );
      if (allApproved) {
        return index === approval_process.length - 1;
      }

      return false;
    },

    getCurrentStepStartTime(approval_process, index) {
      // If there's a previous step and it's approved, use its approval time
      if (index > 0 && approval_process[index - 1]) {
        const previousStep = approval_process[index - 1];
        if (previousStep.status?.toLowerCase() === 'approved' && previousStep.approved_at) {
          return previousStep.approved_at;
        }
      }
      // Otherwise, use the current step's created_at
      return approval_process[index]?.created_at;
    },

    hasPreviousApproval(approval_process, index) {
      if (!approval_process || approval_process.length === 0 || index === 0)
        return false;

      // Check if there's any approved step before the current index
      for (let i = 0; i < index; i++) {
        if (approval_process[i].status?.toLowerCase() === "approved") {
          return true;
        }
      }
      return false;
    },

    exportToPDF() {
      let serialNumber = 1;
      const columns = [ "#SL", "Voucher No", "Voucher Date", "Total Debit", "Total Credit", "Narration", "Approval Status", "Status", ];

      const rows = this.map((item) => [
        serialNumber++,
        item.code || "-",
        item.approvar_name || "-",
        item.voucher_date,
        this.formatCurrency(item.total_debit),
        this.formatCurrency(item.total_credit),
        item.remarks || "-",
        item.approval_status || "Pending",
        this.statusMap[item.status]?.label || "Unknown",
      ]);

      this.$exportTableToPDF( columns, rows, "Journal Voucher Request List (Pending)", "journal_voucher_pending_list_" + this.$fileDate(), "landscape" );
    },

    exportToExcel() {
      var data = [
        [ "#SL", "Voucher No", "Voucher Date", "Total Debit", "Total Credit", "Narration", "Approval Status", "Status", ],
      ];

      var serialNumber = 1;
      this.getPendingVouchers.forEach((item) => {
        data.push([
          serialNumber++,
          item.code || "-",
          item.voucher_date,
          this.formatCurrency(item.total_debit),
          this.formatCurrency(item.total_credit),
          item.remarks || "-",
          item.approval_status || "Pending",
          this.statusMap[item.status]?.label || "Unknown",
        ]);
      });

      this.$exportTableToExcel( data, "journal_voucher_pending_list_" + this.$fileDate());
    },

    exportToCSV() {
      var data = [
        [ "#SL", "Voucher No", "Voucher Date", "Total Debit", "Total Credit", "Narration", "Approval Status", "Status" ],
      ];
      
      var serialNumber = 1;
      this.getPendingVouchers.forEach((item) => {
        data.push([
          serialNumber++,
          item.code || "-",
          item.voucher_date,
          this.formatCurrency(item.total_debit),
          this.formatCurrency(item.total_credit),
          item.remarks || "-",
          item.approval_status || "Pending",
          this.statusMap[item.status]?.label || "Unknown",
        ]);
      });

      this.$exportTableToCSV(
        data,
        "journal_voucher_pending_list_" + this.$fileDate()
      );
    },
  },

  beforeUnmount() {
    this.$store.commit("UNSET_VOUCHER_LIST");
  },
};
</script>

<style scoped>
.edit-button {
  cursor: pointer;
}

.edit-button:hover {
  opacity: 0.7;
}

.panel-header {
  font-weight: 600;
}

/* Table Row Styles */
.voucher-row {
  background-color: white;
}

.voucher-row:hover {
  background-color: #f5f5f5;
}

.timeline-row {
  background-color: #fafafa;
  border-top: 1px solid #e0e0e0;
}

.timeline-container {
  padding: 8px;
  background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
}

/* Horizontal Timeline Styles */
.horizontal-timeline {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-x: auto;
  padding-top: 10px;
  gap: 0;
}

.timeline-step {
  display: flex;
  align-items: flex-start;
  position: relative;
  min-width: 220px;
  flex-shrink: 0;
}

.step-connector {
  width: 60px;
  height: 3px;
  background: #e0e0e0;
  position: absolute;
  top: 15px;
  left: -30px;
  z-index: 0;
  transition: all 0.3s ease;
}

.connector-approved {
  background: #4caf50;
}

.connector-arrow {
  position: absolute;
  right: -6px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid #e0e0e0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  transition: all 0.3s ease;
}

.connector-approved .connector-arrow {
  border-left-color: #4caf50;
}

.step-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.step-number {
  font-size: 0.7rem;
  color: #666;
  font-weight: 600;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 20px;
}

.step-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 1;
  position: relative;
  border: 3px solid white;
  flex-shrink: 0;
}

.step-circle-success {
  background: linear-gradient(135deg, #4caf50 0%, #2e7d32 100%);
}

.step-circle-pending {
  background: linear-gradient(135deg, #ff9800 0%, #ef6c00 100%);
}

.step-circle-blue {
  background: linear-gradient(135deg, #2196f3 0%, #1565c0 100%);
}

.step-circle-error {
  background: linear-gradient(135deg, #f44336 0%, #c62828 100%);
}

.step-circle-grey {
  background: linear-gradient(135deg, #9e9e9e 0%, #616161 100%);
}

.step-card {
  width: 200px;
  border-radius: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.step-circle-success-card {
  border-color: #4caf50;
}

.step-circle-pending-card {
  border-color: #ff9800;
}

.step-circle-blue-card {
  border-color: #2196f3;
}

.step-circle-error-card {
  border-color: #f44336;
}

.step-circle-grey-card {
  border-color: #e0e0e0;
  background: white;
}

.step-title-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
}

.step-role {
  font-size: 0.7rem;
  font-weight: 700;
  color: #1976d2;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.status-approved-text {
  color: #4caf50 !important;
}

.status-pending-text {
  color: #ef6c00 !important;
}

.status-cancelled-text {
  color: #f44336 !important;
}

.step-label {
  font-size: 0.7rem;
  color: #757575;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.step-labelgreen {
  font-size: 0.7rem;
  color: #757575;
  font-weight: 600;
  color: #4caf50;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.step-person {
  font-size: 0.875rem;
  font-weight: 600;
  color: #424242;
  margin-bottom: 8px;
  line-height: 1.3;
}

.step-person.approved {
  color: #2e7d32;
}

.step-person.pending {
  color: #ef6c00;
}

.step-date-label {
  font-size: 0.6rem;
  color: black;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-right: 4px;
}

.step-date {
  font-size: 0.6rem;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-wrap: wrap;
}

.current-step-title-text {
  color: #2196F3 !important;
}

.step-date::before {
  content: "";
  font-size: 0.7rem;
}

.step-comments {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #e0e0e0;
  font-size: 0.7rem;
  color: black;
  font-style: italic;
  line-height: 1.4;
}

/* Current Step Highlight Effects */
.current-step-pulse {
  animation: pulse-ring 2s infinite;
  box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.7);
}

@keyframes pulse-ring {
  0% {
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.7), 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  50% {
    box-shadow: 0 0 0 12px rgba(33, 150, 243, 0), 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0), 0 4px 12px rgba(0, 0, 0, 0.2);
  }
}

@keyframes card-glow {
  0% {
    box-shadow: 0 4px 20px rgba(33, 150, 243, 0.3);
  }

  50% {
    box-shadow: 0 6px 30px rgba(33, 150, 243, 0.5);
  }

  100% {
    box-shadow: 0 4px 20px rgba(33, 150, 243, 0.3);
  }
}

/* Scrollbar styling */
.horizontal-timeline::-webkit-scrollbar {
  height: 8px;
}

.horizontal-timeline::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.horizontal-timeline::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.horizontal-timeline::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.step-role {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
}
</style>
